import { Component, OnInit, Input } from '@angular/core';
import { Follow_up_payment_receipt } from '../../models/follow_up_payment_receipt';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
styleUrls:  ['./payment-receipt.component.css']
})
export class PaymentReceiptComponent extends SmsAbstractAppPage implements OnInit {
	@Input() receipt: Follow_up_payment_receipt;

  constructor() {
  	super();
  }

  ngOnInit() {
  }

}
